module.exports = __webpack_public_path__ + "static/img/product_bg.570ed12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_bg.jpg
// module id = +z0s
// module chunks = 2